<script>
    import gsap from 'gsap';
    import DrawSVGPlugin from 'gsap/DrawSVGPlugin';
    import {onMount, onDestroy} from "svelte";

    gsap.registerPlugin(DrawSVGPlugin);

    let drawLine;
    let tl = gsap.timeline();
    let svgElement;

    onMount(() => {
        const paths = [...Array.from(svgElement.getElementsByTagName('path')), ...Array.from(svgElement.getElementsByTagName('line')), ...Array.from(svgElement.getElementsByTagName('circle'))];

        tl.fromTo(paths, {
            drawSVG: "100% 100%",
            transformOrigin: 'center center',
        }, {
            drawSVG: "100% 0%",
            stagger: 0.01,
            duration: 0.5,
        }, 0);

        tl.play();
    });

    onDestroy(() => {
        tl.clear();
        tl = null;
    })
</script>

<svg xmlns="http://www.w3.org/2000/svg" width="100%" viewBox="0 0 380 678" bind:this={svgElement}>
    <defs>
        <clipPath id="clip-path">
            <rect id="Rectangle_691" data-name="Rectangle 691" width="218.657" height="181.52" fill="none"/>
        </clipPath>
    </defs>
    <rect id="Rectangle_869" data-name="Rectangle 869" width="380" height="678"/>
    <text id="Are_you_greenwashing_or_or_are_you_the_real_deal_" data-name="Are you greenwashing or or are
you the real deal?" transform="translate(40 51.446)" fill="#fcd0b1" font-size="24" font-family="Metric-Regular, Metric">
        <tspan x="0" y="0">Are you greenwashing or are</tspan>
        <tspan x="0" y="28">you the real deal?</tspan>
    </text>
    <text id="_The_pressure_is_mounting._Purpose_ESG_and_sustainability_are_increasingly_important_to_your_positioning._Make_sure_your_ideas_stand_up_to_the_test:_Is_it_something_the_company_can_deliver_"
          data-name="​​The pressure is mounting. Purpose, ESG and sustainability are increasingly important to your positioning. Make sure your ideas stand up to the test:

Is it something the company
can deliver?" transform="translate(40 121)" fill="#fff" font-size="24" font-family="Metric-Regular, Metric">
        <tspan x="0" y="23">​​The pressure is mounting.</tspan>
        <tspan x="0" y="51">Purpose, ESG and sustainability</tspan>
        <tspan x="0" y="79">are increasingly important to</tspan>
        <tspan x="0" y="107">your positioning. Make sure your</tspan>
        <tspan x="0" y="135">ideas stand up to the test:</tspan>
        <tspan x="0" y="163"></tspan>
        <tspan x="0" y="191">Is it something the company</tspan>
        <tspan x="0" y="219">can deliver?</tspan>
    </text>
    <g id="Group_1356" data-name="Group 1356" transform="translate(84 402)">
        <g id="Group_1355" data-name="Group 1355" clip-path="url(#clip-path)">
            <path id="Path_14694" data-name="Path 14694"
                  d="M76.854,172.274c12.674-1.689,9.763-19.863,8.821-28.6-1.248-11.579-3.772-22.962-3.772-34.662,0-20.985,18.3-44.721,31.2-59.841,3.618-4.238,23-24.881,26.248-10.341.5,2.25-.382,4.577-1.483,6.6-2.768,5.1-6.925,9.272-10.409,13.908-5.805,7.725-10.916,17.992-11.511,27.745,7.037-3.978,14.837,1.4,14.837,9.863l-.613,20.045c0,4.913,1.182,8.62,2.537,13.305a60.733,60.733,0,0,1,2.829,18.011c0,14.094-8.391,27.511-22.08,32.212m2.589-93.4a11.4,11.4,0,0,0-5.786,9.555h0l-1.64,38.267a3.758,3.758,0,0,0,.207,1.453"
                  fill="none" stroke="#008ed2" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
            <line id="Line_7875" data-name="Line 7875" x1="5.068" transform="translate(64.474 172.06)" fill="none"
                  stroke="#008ed2" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
            <path id="Path_14695" data-name="Path 14695" d="M58,172.06c-1.408-.094-55.59-.188-57-.282" fill="none"
                  stroke="#008ed2" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
            <path id="Path_14696" data-name="Path 14696"
                  d="M176.66,14.732C176.54,6.3,185.112,1,192.906,1c10,0,19.282,8.928,16.743,19.288-2.269,9.258-14.8,11.1-17.575,20.382a22.664,22.664,0,0,0-.64,6.434m1.083,3.98a3.866,3.866,0,0,1,3.848,3.782,3.935,3.935,0,0,1-2.344,3.7,3.775,3.775,0,0,1-5.255-3.53A3.854,3.854,0,0,1,192.517,51.084Z"
                  fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
            <path id="Path_14697" data-name="Path 14697"
                  d="M153.954,92.8v43.7l31.111,10.37,32.592-10.37V92.06L185.065,79.468Z" fill="none" stroke="#008ed2"
                  stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
            <path id="Path_14698" data-name="Path 14698" d="M185.065,146.875v-43.7l32.592-11.111" fill="none"
                  stroke="#008ed2" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
            <line id="Line_7876" data-name="Line 7876" x2="31.111" y2="10.37" transform="translate(153.954 92.801)"
                  fill="none" stroke="#008ed2" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
        </g>
    </g>
</svg>
